/* eslint-disable react/jsx-props-no-spreading */
import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'
import { useOrderDetail } from '../hooks/orders'

/**
 * Order Detail screen, routed at `/:slug/:sessionId/orders/:orderId`.
 *
 * Thin by design, like `OrderHistory` beside it: fetch on mount, fire
 * analytics, delegate rendering to `Default`. `OrderDetailPanel`, its state
 * copy and its custom slots are authored in SCS config and resolve through
 * `importRoute`, so no layout belongs in this file — and the three props the
 * config cannot express are injected in `useCinnamonProps`, not passed here.
 */
const OrderDetail: FC<ITemplate> = ({ ...props }) => {
  useOrderDetail()

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])

  return <Default {...props} />
}

export default OrderDetail
